import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedList, LinkedProject } from "./types";
import { list as listMock } from "@planzone/dto";

function linkList(httpClient: HttpClient) {
  return function link(list: LinkedList): Promise<LinkedList> {
    return Promise.all([
      list.project
        ? Promise.resolve({ project: list.project })
        : httpClient
            .sendHttpRequest<LinkedProject>({
              endpoint: list._links.project.href,
              baseUrl: "",
              method: HttpMethods.GET,
            })
            .then((project) => ({ project })),
      list.activityParent || list.parentList
        ? Promise.resolve({
            parentList: {
              ...listMock,
              ...(list.activityParent || list.parentList),
            },
          })
        : httpClient
            .sendHttpRequest<LinkedList>({
              endpoint: list._links.activityParent.href,
              baseUrl: "",
              method: HttpMethods.GET,
            })
            .then((parentList) => ({
              parentList: { ...listMock, ...parentList },
            }))
            .catch(() => ({})),
    ])
      .then((responses) =>
        responses.reduce<LinkedList>(
          (nextList, chunk) => ({ ...nextList, ...chunk }),
          list,
        ),
      )
      .then((list) => ({
        ...list,
        subLists: (list.subLists || []) as LinkedList[],
        parentList: list.parentList,
        tags: list.tags
          ? (list.tags as any).map((name: string) => ({ name }))
          : [],
        milestones: Array.isArray(list.milestones) ? list.milestones : [],
      }));
  };
}

export { linkList };
